import { OperationType } from 'shell/view-models/operation';

type QueryOperationSerializableObject = {
  value: string | number | boolean;
  operation?: OperationType;
};

export type OperationObject = {
  [key: string]: QueryOperationSerializableObject;
};
export const filtersOperationObjectToQueryString = (object: OperationObject): string => {
  const copyObject = { ...object };
  const objectKeys = Object.keys(copyObject);
  const hasKeys = objectKeys.length > 0;
  let count = 0;
  const queryString = hasKeys
    ? objectKeys
        .map((propertyKey) => {
          if (copyObject[propertyKey].value != '' && copyObject[propertyKey].value != undefined) {
            count++;
            if (count === 1) {
              return `${propertyKey}=${copyObject[propertyKey].value}`;
            }
            return `&${propertyKey}=${copyObject[propertyKey].value}`;
          }
        })
        .join('')
    : '';

  return queryString;
};
